// 添加防护措施，处理多个钱包扩展导致的ethereum属性重定义问题
; (function () {
  // 1. 尝试捕获全局TypeError，防止ethereum属性重定义错误崩溃应用
  const originalErrorHandler = window.onerror
  window.onerror = function (message, source, lineno, colno, error) {
    if (message && message.includes('Cannot redefine property: ethereum')) {
      // 忽略这个特定错误，防止应用崩溃
      console.warn('Ignored "Cannot redefine property: ethereum" error from external script')
      return true // 阻止错误传播
    }
    // 其他错误使用原始处理程序
    if (originalErrorHandler) {
      return originalErrorHandler(message, source, lineno, colno, error)
    }
    return false
  }

  // 2. 尝试保护window.ethereum属性
  try {
    // 检查window.ethereum是否已经存在
    if (window.ethereum) {
      // 如果存在，尝试将其配置为可重新定义
      try {
        Object.defineProperty(window, 'ethereum', {
          configurable: true,
          writable: true,
          value: window.ethereum
        })
      } catch (error) {
        console.warn('Failed to make window.ethereum configurable:', error)
      }
    }
  } catch (error) {
    console.warn('Error in ethereum protection:', error)
  }
})()

import Vue from 'vue'
import App from './App.vue'
import vuex from 'vuex'
import store from './store'
import router from './router'
import '@/assets/iconfont/iconfont.css'
import "vue-toastification/dist/index.css";
import 'vue-loading-overlay/dist/vue-loading.css';
import VueI18n from 'vue-i18n'
import VueClipboard from 'vue-clipboard2'
import Meta from 'vue-meta'
import Toast from 'vue-toastification'
import Loading from "vue-loading-overlay";
import '@/assets/font/googleFont.css' // 引入全局的Google Fonts
import '@/assets/global/css/enterprise-theme.css' // 引入企业级暗黑主题
import SvgTransition from 'vue-svg-transition'
import { getCookie, setCookie } from './utils/cookie'
Vue.config.productionTip = false
Vue.use(vuex)
Vue.use(VueI18n)
Vue.use(VueClipboard)
Vue.use(Toast)
Vue.use(Meta)
Vue.use(Loading)
Vue.use(SvgTransition)
Vue.use(Toast, {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 20,
  newestOnTop: true,
  position: 'top-right',
  timeout: 2000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: 'button',
  icon: true,
  rtl: false
})
const locale = getCookie('language') || 'en'
setCookie('language', locale)
const i18n = new VueI18n({
  locale,
  messages: {
    zh: require('@/assets/language/zh.json'),
    en: require('@/assets/language/en.json')
  }
})
Vue.prototype.$i18nn = i18n // 将国际化工具 挂载到 vue原型上面
let vueThis = new Vue({
  i18n,
  store,
  router,
  metaInfo() {
    return {
      title: this.$t('seo.product.title'), // Default title
      titleTemplate: '%s' + this.$t('seo.common.suffix'), // e.g. "%s - Utools"
      meta: [
        {
          name: 'keywords',
          content: this.$t('seo.product.keywords')
        },
        {
          name: 'description',
          content: this.$t('seo.product.description')
        }
      ]
    }
  },
  render: h => h(App)
}).$mount('#app')
export default vueThis
